<div *ngIf="data">
    <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 7px">
      <div class="col-sm-11 movable">
        <h3
          class="head"
          cdkDrag
          cdkDragHandle
          cdkDragRootElement=".cdk-overlay-pane"
        >
          CONTAINER TAP
        </h3>
      </div>
  
      <div class="col-sm-1">
        <button
          type="button"
          class="btn btn-dark btn-circle btn-xl"
          [mat-dialog-close]="true"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="successMessage alert-dismissible">
        <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
          {{ warningMessage }}
          <button
            type="button"
            class="btn-close"
            (click)="removeMessage()"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
    
        <div *ngIf="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="drpchildctrl">
            <label required class="searchLable">RENBAN</label>
            <label required class="">{{container_renban}}</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="drpchildctrl">
            <label required class="searchLable">MODULE</label>
            <label required class="">{{module_number}}</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="drpchildctrl">
            <label required class="searchLable">STOCKING DATE TIME</label>
            <label required class="">{{stocking_datetime}}</label>
        </div>
      </div>  
      </div>
    </div>  
    <div class="col-md-12">
      <ag-grid-angular #osPartsGrid style="
          width: 100%;
          margin-top: 35px;
          height: 300px !important;
          top: 3%;
          margin-bottom: 2%;
        " class="ag-theme-balham table-outer" [rowData]="rowData" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [gridOptions]="gridOptions" [context]="context" [editType]="editType" [suppressClickEdit]="suppressClickEdit"
         [suppressClickEdit]="true" >
      </ag-grid-angular>
    
    </div>
    <div class="text-right" style="margin-top: 15px">
      <!-- <button class="review_btn" mat-button > -->
      <button *ngIf="this.data.accessEdit" class="review_btn" mat-button (click)="updateStockTap()">
        Save
      </button>
  
      <button class="cancel_btn" mat-button mat-dialog-close="cancel">
        Cancel
      </button>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading... Please wait...</p>
  </ngx-spinner>